import { useContractorContext } from '@features/Contractor/ContractorContext'
import { ContractorProfile } from '@features/Contractor/ContractorProfile'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/contractor/$contractorId/')({
  component: ContractorOverviewRoute,
  staticData: {
    breadcrumb: 'Oversikt',
  },
})

function ContractorOverviewRoute() {
  const { data, isLoading, isError, refetch } = useContractorContext()

  return <ContractorProfile data={data} isLoading={isLoading} isError={isError} onRetry={refetch} />
}
